import { createTheme } from '@material-ui/core/styles'

export const materialTheme = createTheme({
	palette: {
		primary: {
			main: '#f50537',
		},
	},
})
